import React, { Component } from 'react';
import { connect } from 'react-redux';

class TermsOfUse extends Component {
  render() {
    let book = this.props.store.tla === "DVD" ? "" : "book";
    let company = this.props.store.tla === "DVD" ? "Edge Line Ventures, LLC" : "Bookspan, LLC";
    return (
      <div className="content-max-width cms">
        <div className="content-max-width">
          <a href="/" className="button btn-secondary float-right" onClick={(evt) => this.props.dispatch( navigate(evt))}>Continue shopping</a>
          <h2>Terms of Use</h2>
        </div>
        <div className="modal-body">
          <p>
            Welcome to {this.props.store.name}! This Web site located at {this.props.store.url} (the "Site") is owned and operated
            by {company}. {this.props.store.name} maintains this site (the "Site") for your personal entertainment, information,
            education and communication.
          </p>
          <h6>MEMBERSHIP INFORMATION</h6>
          <p>
            {this.props.store.name} operates a membership program which is controlled by the terms of the membership agreement.
          </p>

          <h6>REVISIONS</h6>
          <p>
            {this.props.store.name} may at any time revise the terms and conditions herein by updating these Terms of Use.
            You are bound by any such revisions and should therefore periodically visit this page to review the
            then-current terms and conditions.
          </p>

          <h6>TRADEMARKS</h6>
          <p>
            The trademarks, logos and service marks (the "Trademarks") displayed on the Site, unless otherwise
            specified, are either the registered and unregistered trademarks of {this.props.store.name}’s parent entity or
            used under license. Nothing contained in the Site should be construed as granting by implication or
            otherwise, any license or right to use any Trademark displayed in the Site without the written permission
            of {this.props.store.name} or any third party that may own the Trademarks displayed on the Site. Your misuse of the
            Trademarks displayed on the Site, or any other content on the Site, is strictly prohibited. You are hereby
            also advised that {this.props.store.name} will aggressively enforce its intellectual property rights to the fullest
            extent of the law, including the seeking of criminal prosecution.
          </p>

          <h6>OWNERSHIP</h6>
          <p>
            Everything you see or read on the Site is copyrighted unless otherwise noted and may not be used except as
            provided for in these terms and conditions or in the text of the Site without the express permission of
            {" " + this.props.store.name} which neither warrants nor represents that your use of materials displayed on the Site will
            not infringe rights of third parties not owned or affiliated with {this.props.store.name}. You may only download
            material displayed on the Site for non-commercial, personal use provided you also retain all copyright,
            trademark and other proprietary notices contained in the material. It is strictly prohibited to modify,
            transmit, distribute, reuse, re-post, "frame" or use the content of the Site for public or commercial
            purposes including the text, images, audio and/or video without {this.props.store.name}’s written permission. It is
            strictly prohibited to download the images of the products for sale within this site.
          </p>

          <h6>INTELLECTUAL PROPERTY, PRIVACY, AND PUBLICITY </h6>
          <p>
            Images of people or places displayed in this Site are either the property of, or used with permission by
            {" " + this.props.store.name}. The use of these images by you, or anyone authorized by you, IS PROHIBITED unless specifically
            permitted by these terms and conditions or specific permission provided elsewhere on the Site or you secure
            the necessary permission from the rights holder. Any unauthorized use of the images may violate copyright laws,
            trademark laws, the laws of privacy and publicity, and communications regulations and statutes.
          </p>

          <h6>CONFIDENTIALITY</h6>
          <p>
            Any communication or material you transmit to the Site by electronic mail or otherwise, including any data,
            questions, comments, suggestions, or the like is, and will be treated as, non-confidential and non-proprietary.
            Anything you transmit or post may be used by {this.props.store.name} or its affiliates for any purpose, including but not
            limited to, reproduction, disclosure, transmission, publication, broadcast and posting. {this.props.store.name} is free to
            use any ideas, concepts, know-how or techniques contained in any communication you send to the Site for any
            purpose whatsoever including, but not limited to, developing, manufacturing and marketing products using such
            information. You are prohibited from posting or transmitting any unlawful, threatening, libelous, defamatory,
            obscene, scandalous, inflammatory, pornographic, or profane material or any material that could constitute or
            encourage conduct that would be considered a criminal offense, give rise to civil liability or otherwise violate
            any law. {this.props.store.name} reserves the right to remove any content posted at any time at its sole discretion.
            {this.props.store.name} will fully cooperate with any law enforcement authorities or court order requesting or directing
            {" " + this.props.store.name} to disclose the identity of anyone posting such information or materials.
          </p>

          <h6>SECURITY</h6>
          <p>
            We maintain physical, electronic, and procedural safeguards that meet or exceed industry standards to guard
            your nonpublic personal information. We protect your account information by placing it on the secure portion
            of our Web site, using firewalls and other security technology to protect our network and systems from external
            attacks, and requiring you to enter a unique user name and password to access your account information online.
            Also, our servers have been enabled with Secure Sockets Layer (SSL) technology to prevent unauthorized parties
            from viewing the nonpublic personal information that you provide or access during a secure session (look for the
            padlock icon on your browser).
          </p>

          <h6>DIGITAL MILLENNIUM COPYRIGHT ACT (PUBLIC LAW 105-304) WEBSITE POLICY AND PROCEDURES FOR COMPLIANCE</h6>
          <p>
            In accordance with the Digital Millennium Copyright Act, this Site has adopted a policy toward copyright
            infringement on its {book} club website. In furtherance of this policy, this Site will block access to and/or
            remove any material that it believes in good faith to be copyrighted material that has been illegally copied
            and submitted to our Site. This policy shall cover all aspects of the Site, including but not limited to author
            chats, images, graphics, {book} reviews, and all member-generated content posted on any portion of our Sites.
          </p>

          <h6>PROCEDURE FOR REPORTING COPYRIGHT INFRINGEMENTS</h6>
          <p>
            First, submit a formal Notice of Copyright Infringement containing the following information:
          </p>
          <ol>
            <li>1. The material being infringed or otherwise objectionable</li>
            <li>2. Where on the site the infringements are located</li>
            <li>3. The name of the person/entity complaining </li>
            <li>4. How this person/entity may be contacted </li>
            <li>5. A signed statement that the complainant has good faith belief that the material is infringing or
            unlawful and </li>
            <li>6. A statement made under penalty of perjury that content of the Notice is truthful and the complaint is expressly
            authorized by the copyright holder to submit the Notice</li>
          </ol>

          <p>
            Next, send the Notice of Copyright Infringement to this site’s Designated Copyright Infringement Agent:
            {this.props.store.name} 34 W 27th Street, 10th Floor, New York, NY 10001 Attn: Legal Affairs Fax (516) 490-4021 or via
            email to: {this.props.store.member_services_email}
          </p>
          <p>
            Within a reasonable time after this information is received, the following action will be taken:
          </p>
          <ol>
            <li>1. The infringing material or Site will be blocked </li>
            <li>2. Reasonable efforts will be taken to promptly inform the infringing user of the situation</li>
            <li>3. In the case of first-time offenders, the infringing material will be removed </li>
            <li>4. To the extent possible, repeat offenders will be removed permanently from the system.</li>
          </ol>

          <p>
            The infringing user may respond with a counter notice which may include a signed statement, made under penalty of
            perjury, that the user has a good faith belief that the removal or disablement was a result of a mistake or
            misidentification. A complete listing of the infringing user’s contact information and consent to jurisdiction in
            Federal Court in the infringing user’s district must also be included, along with a statement that the infringing
            user will accept service of process from the original complainant. If such counter notice is received by the
            site’s Designated Copyright Agent, a copy of the counter notice will be sent to the original complainant.
            The user’s material and access will be restored in 10 to 14 days unless the Designated Copyright Agent is
            informed that a lawsuit has been filed over the infringing material.
          </p>

          <h6>ACCURACY </h6>
          <p>
            While {this.props.store.name} uses reasonable efforts to include accurate and up-to-date information on the Site,
            {" " + this.props.store.name} makes no warranties or representations as to its accuracy, nor does {this.props.store.name} assume any liability or
            responsibility for any errors in the content of the Site.
          </p>

          <h6>DAMAGES AND WARRANTIES</h6>
          <p>
            Your use of and browsing in the Site are at your own risk. Neither {this.props.store.name} nor any other party involved in
            creating, producing or delivering the Site is liable for any direct, incidental, consequential, indirect or punitive
            damages arising out of your access to or use of the Site. Without limitation, everything on the Site is provided to
            you "AS IS" without warranty of any kind, either express or implied, including but not limited to the implied
            warranties of merchantability, fitness for a particular purpose or non-infringement. Note that some jurisdictions may
            not allow the exclusion of implied warranties, so some of the above exclusions may not apply to you. Check your local
            laws for any restrictions or limitations regarding the exclusion of implied warranties.
          </p>

          <h6>NOTICE OF ARBITRATION AGREEMENT</h6>
          <p>
            We and you agree to arbitrate all disputes and claims between us arising out of or relating to this Agreement, as
            broadly interpreted to include any aspect of our relationship, including claims related to advertising. You thus
            give up your right to go to court, except that you may bring an action against us in small claims court. The
            arbitration will be under the prevailing Commercial Arbitration Rules and the Supplementary Procedures for Consumer
            Related Disputes of the American Arbitration Association (the “AAA Rules”), as modified by this Agreement. The
            AAA Rules, including how to initiate a claim, are available online at www.adr.org or by calling the AAA at
            800-778-7879. If you choose arbitration, your rights will be determined by a neutral arbitrator and not a judge
            or jury. You are entitled to a fair hearing, but arbitration procedures are simpler and more limited than rules
            applicable in court. Arbitrator decisions are as enforceable as any court order and are subject to very limited
            review by a court. Arbitrations will be conducted by one Arbitrator and will be Desk Arbitrations unless you or we
            request a Telephonic Hearing (as defined by AAA Rules). There will be no In-Person Hearing unless a claim seeks more
            than $75,000. We will pay all filing, administration, and arbitrator fees, unless the Arbitrator finds that your
            claim had no reasonable foundation or was brought for an improper purpose, in which case the Arbitrator must order
            you to pay those costs. After you notify us that you have commenced arbitration, we will promptly reimburse you the
            filing fee. If the Arbitrator issues an award in your favor on the merits of your claim that is greater than the
            value of our last written settlement offer made before the Arbitrator was selected, then the Arbitrator also may
            award you your reasonable attorney’s fees. We will not seek attorney’s fees from you even if we prevail. The
            Arbitrator will be bound by this Agreement. The Arbitrator may award declaratory or injunctive relief only in
            favor of the party seeking relief and only as necessary to provide relief warranted by that party's individual
            claim. You and we agree that each may bring claims against the other only in your or our individual capacity
            and not as a plaintiff or class member in any purported class or representative proceeding. Further, unless both
            you and we agree otherwise, the Arbitrator may not consolidate more than one person's claims, and may not otherwise
            preside over any form of a representative or class proceeding. If this specific provision is found to be unenforceable,
            then the entirety of this arbitration provision shall be null and void.
          </p>

          <h6>VIRUS</h6>
          <p>
            {this.props.store.name} also assumes no responsibility, and shall not be liable for any damages to, or viruses
            that may infect, your computer equipment or other property on account of your access to, use of, or browsing in,
            the Site or your downloading of any materials, data, text, images, video or audio from the Site.
          </p>

          <h6>LINKS</h6>
          <p>
            {this.props.store.name} has not reviewed all of the sites linked to the Site, is not responsible for the content of any
            off-Site pages or any other sites linked to the Site. Your linking to any other off-Site pages or other sites is at
            your own risk and the fact that there is a link to {this.props.store.name} site should not be construed as an endorsement of
            either the linked Site’s content or sponsors.
          </p>
          <p>
            This policy is effective as of: March 30, 2015
          </p>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'store': state.store };
}

export default connect(mapStateToProps)(TermsOfUse);


// WEBPACK FOOTER //
// ./src/components/CmsTermsOfUse.jsx